import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sx", "color", "size"];
import PropTypes from 'prop-types';
import * as React from 'react';
import MuiAlert from '@mui/material/Alert';
import { extendSX } from '../helpers';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Alert](https://ui-packages.isbuildingluma.com/ui-core/react-alert/)
 *
 * API:
 *
 * - [Alert API](https://ui-packages.isbuildingluma.com/ui-core/api/alert/)
 * - inherits [MuiAlert API](https://mui.com/material-ui/api/alert/)
 */
const Alert = /*#__PURE__*/React.forwardRef(function Alert(props, ref) {
  const {
      sx,
      color,
      size
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const smallSize = size === 'small';
  return /*#__PURE__*/_jsx(MuiAlert, _extends({
    ref: ref,
    className: smallSize ? 'MuiAlert-smallSize' : undefined
    // Casting because we want to avoid using `AlertPropsColorOverrides`
    // More info: https://mui.com/material-ui/customization/palette/#adding-new-colors
    ,
    color: color,
    sx: extendSX(sx)
  }, rest));
});
process.env.NODE_ENV !== "production" ? Alert.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "AlertProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   */
  color: PropTypes.oneOf(['error', 'info', 'primary', 'quaternary', 'secondary', 'success', 'tertiary', 'warning']),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOf(['small', 'medium']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export default Alert;